import React from 'react';
import Avatar from 'material-ui/Avatar';

class OrderTableCell extends React.Component {
    constructor() {
        super();
        this.state = {}
    }

    render() {
        const {anchorEl, menuState} = this.state;
        const {id, orderId, username, image, createDate, modifiedDate, step, stepTitle} = this.props.data;
        const statusStyle = step < 4 ? "text-white bg-grey" : step < 6 ? "bg-amber" : step < 8 ? "text-white bg-danger" : "text-white bg-success";


        return (
            <tr
                tabIndex={-1}
                key={id}
            >
                <td className='text-center'>{orderId}</td>
                <td>
                    <div className="user-profile d-flex flex-row align-items-center justify-content-center">
                        <Avatar
                            alt={username}
                            src={image}
                            className="user-avatar"
                        />
                    </div>
                </td>
                <td className='text-center'>
                    <div className="user-detail">
                        <h5 className="user-name">{username} </h5>
                    </div>
                </td>
                <td className='text-center'>{createDate}</td>
                <td className='text-center'>{modifiedDate}</td>
                <td className="status-cell text-center">
                    <div className={` badge text-uppercase ${statusStyle}`}>{stepTitle}</div>
                </td>
            </tr>

        );
    }
}

export default OrderTableCell;



// WEBPACK FOOTER //
// ./components/toliton/desktop/latestOrders/OrderTableCell.js